<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.selfService.addressQuest') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.selfService.addressDescription') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="address"
        @change="update"
        data-vs-radio-button="address"
      >
        <span class="custom-label">{{
          $t('message.selfService.radioOk')
        }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full mb-4">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="address"
        @change="update"
        data-vs-radio-button="address"
      >
        <span class="custom-label">{{
          $t('message.selfService.radioNot')
        }}</span>
      </zt-radio-button>
    </div>
    <div v-if="selected === 'true' && isCompanyFromArgentina" class="mt-16">
      <h2 class="custom-title custom-color-gray font-medium mb-4">
        {{ $t('message.selfService.whereToStoreDocument') }}
      </h2>
      <p class="custom-legend text-zt-dark-300 mb-4">
        {{ $t('message.selfService.selectFolderForUpdateDocument') }}
      </p>

      <p v-if="errorsArray.length" class="text-zt-danger text-zt-md mb-2">
        {{ $t('message.selfService.selectFolderError') }}
      </p>

      <div class="relative">
        <div class="flex">
          <zt-button
            outlined
            class="w-3/4 py-2 flex btn-select"
            icon="caret-down"
            icon-after
            @click="toggleDropdownFolder"
          >
            <zt-icon name="folder-solid icon-color" class="pb-2 pr-3" />
            {{ selectedOption.name }}
          </zt-button>
        </div>
        <div
          v-if="isFolderOpen"
          class="absolute w-3/4 bg-white border border-gray-300 rounded shadow-lg z-40 overflow-auto max-h-60"
        >
          <div
            v-for="(item, index) in foldersAvalible"
            :key="index"
            @click="selectFolderOption(item)"
          >
            <div class="flex px-4 py-3 cursor-pointer hover:bg-gray-200">
              <zt-icon name="folder-solid icon-color" />
              <p class="pl-4">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedOption.id" class="mt-16">
      <p class="custom-legend text-zt-dark-300 mb-4">
        {{ $t('message.selfService.whichTypeToStoreDocument') }}
      </p>

      <div class="relative">
        <div class="flex">
          <zt-button
            outlined
            class="w-3/4 py-2 flex btn-select"
            icon="caret-down"
            icon-after
            @click="toggleDropdownType"
          >
            <zt-icon
              name="download-paper-solid icon-color text-2xl"
              class="pb-2 pr-3"
            />
            {{ selectedTypeOption.type_name }}
          </zt-button>
        </div>
        <div
          v-if="isTypeOpen"
          class="absolute w-3/4 bg-white border border-gray-300 rounded shadow-lg z-40 px-2 overflow-auto max-h-60"
        >
          <div
            v-for="(item, index) in documentsTypeAvailable"
            :key="index"
            @click="selectTypeOption(item)"
          >
            <div class="flex px-4 py-3 cursor-pointer hover:bg-gray-200">
              <zt-icon name="download-paper-solid icon-color text-2xl" />
              <p class="pl-4">{{ item.type_name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Folders from '@/apiClient/Folders'
export default {
  name: 'EnableAddressUpdate',
  inject: ['configurationState', 'setParams'],
  data() {
    return {
      selected: 'false',
      foldersAvalible: [],
      documentsTypeAvailable: [],
      isFolderOpen: false,
      isTypeOpen: false,
      selectedOption: { value: null, name: this.$t('message.selfService.selectFolder') },
      selectedTypeOption: {
        value: null,
        type_name: this.$t('message.selfService.selectDocumentType')
      },
      errorsArray: [],
      isCompanyFromArgentina: false
    }
  },
  async created() {
    this.selected = this.configurationState.params.address.enable.toString()
    this.isCompanyFromArgentina =
      this.$store.state.country === 'ar' ? true : false
    this.folders = new Folders()
    await this.getFoldersAvalible()
    await this.setInitialFolder()
  },
  methods: {
    update() {
      const enable = /^(true|1)$/i.test(this.selected) && !!this.selected
      this.setParams('address', { enable })
      console.log("enable", enable)
      if (!enable) {
        this.selectedOption = { value: null, name: this.$t('message.selfService.selectFolder') }
        this.setParams('idfolder', { idfolder: '' })
        this.setParams('idtypedocument', { idtypedocument: '' })
        if (this.selectedOption.id) {
          this.selectedTypeOption = {
            value: null,
            type_name: this.$t('message.selfService.selectDocumentType')
          }
        }
      }
    },
    async getFoldersAvalible() {
      try {
        this.errorsArray = []
        const { data } = await this.folders.getFoldersSettingsAvailable({
          visible: 1,
          firmable: 0,
          efimero: 0
        })

        this.foldersAvalible.push(...data.data)
      } catch (error) {
        this.foldersAvalible = []
        this.errorsArray.push(error)
      }
    },
    async getTypesAvalible() {
      try {
        const folderId = this.selectedOption.id
        const { data } = await this.folders.getDocumentType(folderId)
        this.documentsTypeAvailable.push(...data.data)
      } catch (error) {
        this.documentsTypeAvailable = []
      }
    },
    toggleDropdownFolder() {
      this.isFolderOpen = !this.isFolderOpen
      if (this.isFolderOpen) this.isTypeOpen = false
    },
    toggleDropdownType() {
      this.isTypeOpen = !this.isTypeOpen
      if (this.isTypeOpen) this.isFolderOpen = false
    },
    async setInitialFolder() {
      if (
        this.configurationState.idfolder !== '' &&
        this.isCompanyFromArgentina
      ) {
        const selectedIdFolder = this.configurationState.idfolder.toString()
        this.selectedOption = this.foldersAvalible.find(
          (item) => item.id === selectedIdFolder
        )

        if (this.configurationState.idtypedocument !== '') {
          const selectedidtypedocument =
            this.configurationState.idtypedocument.toString()
          await this.getTypesAvalible()
          this.selectedTypeOption = this.documentsTypeAvailable.find(
            (item) => item.type_id === selectedidtypedocument
          )
        }
      }
    },
    async selectFolderOption(option) {
      this.selectedOption = option
      this.isFolderOpen = false
      const idfolder = this.selectedOption.id
      this.setParams('idfolder', { idfolder })
      this.setParams('idtypedocument', { idtypedocument: '' })
      this.documentsTypeAvailable = []
      this.selectedTypeOption = {
        value: null,
        type_name: this.$t('message.selfService.selectDocumentType')
      }
      await this.getTypesAvalible()
    },
    selectTypeOption(option) {
      this.selectedTypeOption = option
      this.isTypeOpen = false
      const idtypedocument = this.selectedTypeOption.type_id
      this.setParams('idtypedocument', { idtypedocument })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #2d2d2d;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
.btn-select {
  justify-content: flex-start;
}
.icon-color {
  color: #898dff;
}
.max-h-60 {
  max-height: 160px;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>
